import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CitationSourceCardDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    footer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    container: {
        flexDirection: "column"
    },
    source: {
        flexDirection: "column"
    },
    head: {
        alignItems: "center",
        flexDirection: "row"
    },
    pager: {
        alignItems: "center",
        flexDirection: "row"
    },
    domain: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: CitationSourceCardDynamicStyleType) => {
    const styles = {
        pager: {
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>,
        source: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        head: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        footer: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
